import  sanityClient  from "@sanity/client";

export default sanityClient({
    projectId:"v83ri7p3",
    dataset:"production"
})